import { Address, Province, Locality } from './address';

export interface Authorization {
  policy: string;
  policyType: string; // policyType == productDescription
  productCode: string;
  cis: string;
  documentId: string;
  name: string;
  clientId?: string;
  origin?: any;
  haveDocument?: boolean;
  documentNumber?: string;
  medicalCenter?: HealthMedicalCenterDetail;
  hospitalizationCenter?: HealthMedicalCenterDetail;
  hospitalizationDate?: string;
  benefit?: BenefitGroup;
  subcategory?: Benefit;
  sessions?: number;
  phone?: string;
  mobil?: string;
  email?: string;
  result?: AuthorizationResponse;
  prescriptor?: HealthPrescriberDocument;
  authSMS?: boolean;
}

export interface HealthAuthorization {
  date: string; // fecValidez
  description: string;
  status: string; // codEstadoAutorizacion
  number: string; // numAutorizacion
}

export interface BenefitGroup {
  code: number; // codGroup
  name: string; // name
  benefits: Benefit[]; // actCollection
  // actNumber == benefits.legth
}

export interface Benefit {
  specialityCodes: string[]; // codSpeciality
  codes: string[]; // codAct
  name: string; // name
  requiresHospitalization: boolean; // indHospitalization
  sessions: number; // numSessions
  admitsPrescriptionDocument: boolean; // indUnicDocument
  franchiseImport: number; // costFranchise
}

export interface HealthPrescriberDocument {
  // PrescriptorObj
  prescriberCode: number; // codPrescriptor
  prescriberName: string; // nomPrescriptor
  prescriberSurname1: string; // prescriptor1
  prescriberSurname2: string; // prescriptor2
  prescriberSpecialityCode: number; // especialidad
  prescriberSpecialityName: string; // desEspecialidadPrescriptor
  prescriberSpecialityDescription: string; // litEspecialidadPrescriptor
  oimSpeciality: boolean; // indEspecialidadOIM
}

export interface HealthMedicalCenter {
  // MedicalCenterObj
  serviceNumber: number; // serviNum
  serviceSpecialityCode: number; // codEspecialidadServicio
  serviceSpecialityDescription: string;
  scaleSpecialityCode: number; // codEspecialidadBaremo
  scaleActCode: number; // codActoBaremo
  mapfreCenter: boolean; // centroMapfre
  preferential: boolean; // esPreferente
  name: string; // nomServicio
  phone1: string; // telefono1
  phone2: string; // telefono2
  address: Address;
}

export interface HealthMedicalCenterDetail {
  // MedicalCenterDetailObj
  serviceNumber: number; // serviNum
  specialityCode: number;
  specialityDescription: string;
  requiereCitaPrevia: string;
  remarks: string; // observaciones
  requiresAppointment: boolean;
  name: string; // nomServicio
  phone1: string; // telefono1
  phone2: string; // telefono2
  fax: string; // fax
  webUrl: string; // urlWeb
  province: Province;
  locality: Locality;
  address: Address; // direccion
  schedules: DayMorningEveningShiftSchedule[]; // tablaHorarios
  specialities: HealthSpeciality[]; // tablaEspecialidades
}

export interface DayMorningEveningShiftSchedule {
  // TablaHoriosObj
  day: string; // dia
  morningInitHour: string; // horinim
  morningEndingHour: string; // horfnim
  eveningInitHour: string; // horinit
  eveningEndingHour: string; // horfnit
  shift: string; // turno
}

export interface HealthSpeciality {
  // TablaEspecialidadesObj
  code: number; // codEspecialidad
  description: string; // desEspecialidad
  doerCode: number; // codRealizador
  doerName: string; // nomRealizador
}

export interface SpecialityInfo {
  code: string;
  name: string;
  description: string;
}

export interface AuthorizationRequest {
  hospitalizationCenterCode: number;
  specialityCode: number;
  prescriberCode: number;
  doerCode: number;
  benefitCode: number;
  phone: string;
  mobilePhone: string;
  email: string;
  name: string;
  documentNumber: string;
  entryDate: string;
  acceptsSMS: boolean;
  prescriptionDocumentNumber: string;
  uniquePrescriptionDocument: boolean;
  maxSessions: number;
}

export interface AuthorizationResponse {
  // AuthorizationResultObj
  authorization: HealthAuthorization;
  reasonCode: string; // codMotivo
  reasonDescription: string; // desMotivo
  oimReason: boolean; // indMotivoOIM
  flyers: HealthFlyer[]; // volantes
}

export interface HealthFlyer {
  // VolanteAuthorizationObj
  specialityDescription: string; // desEspecialidad
  medicalCenterDescription: string; // desMedCenRealizador
  issueDate: string; // fecEmision
  flyerNumber: string; // numVolante
  flyerType: string; // tipoVolante
}

export enum UserStatus {
  ONLINE_CAMPAIGN = 20
}
